// This is just an example,
// so you can safely delete all default props below

export default {
  site: {
    title: 'ステータスChecker',
  },
  btn: {
    logout: 'ログアウト',
    update: '更新',
    create: '新規作成',
    delete: '削除',
    action: 'アクション',
    add: '作成',
    edit: '編集',
    view: '詳細',
    cancel: 'キャンセル',
  },
  page: {
    dashboard: { name: 'ダッシュボード' },
    events: { name: 'イベント' },
    incidents: { name: 'インシデント' },
    enquetes: {
      name: 'アンケート',
      info: { name: 'アンケート概要' },
      targetResources: { name: '回答状況', subTitle: '対象リソース一覧' },
      tallying: { name: '集計グラフ' },
    },
    questionTemplates: { name: '設問テンプレート' },
    mailTemplates: { name: 'メールテンプレート' },
    enqueteTemplates: { name: 'アンケートテンプレート' },
    accounts: { name: 'アカウント' },
    groups: { name: 'グループ' },
    groupTypes: { name: 'グループタイプ' },
    resourceTypes: { name: 'リソースタイプ' },
    resources: { name: 'リソース' },
    groupResources: {
      name: 'グループとリソース',
      noGroup: { name: 'グループなし' },
    },
    mypage: { name: 'マイページ' },
    bulk: { name: 'マスター一括処理' },
  },
  field: {
    common: {
      id: 'ID',
      name: '名前',
      email: 'メールアドレス',
      keyword: 'キーワード',
    },
  },
  pageType: { view: '詳細', create: '新規作成', edit: '編集', search: '検索' },
  validation: {
    required: '入力してください',
    selectionRequired: '選択してください',
    email: 'メールアドレス形式にしてください',
    min: '%{length}文字以上にしてください',
    max: '%{length}文字以下にしてください',
    includeLowercase: '英字の小文字を含めてください',
    includeUppercase: '英字の大文字を含めてください',
  },

  failed: '実行に失敗しました',
  success: {
    create: '作成しました',
    update: '更新しました',
    delete: '削除しました',
  },
  error: {
    S001: 'データの登録に失敗しました',
    S002: 'データの取得に失敗しました',
    S003: 'データが見つかりません',
    S004: '対象のデータがありません',
    S005: 'データの更新に失敗しました',
    S006: 'データの削除に失敗しました',
    U000: '不明なエラーです',
    A001: '認証情報がありません',
    A002: '認証を検証できません',
    A003: '認証されていません',
    A004: '該当するユーザが存在しません',
    P001: '権限がありません',
    R001: 'リクエストが不正です',
    R002: '不正なパラメータです',
    R003: '既にEmailが存在しています',
    R004: 'CSVファイルのヘッダー項目が不正です',
    unknown: 'エラーが発生しました',
  },
};
